/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {AdditionalCustomerType} from '@dms/api/sales';

export const CHECKOUT_ADDITIONAL_CUSTOMER_DEFAULT_ROLE: AdditionalCustomerType = 'operator';
